import React from "react";
import Sidebar from "./Sidebar";
import BottomNav from "./BottomNav";
import TopBar from "./TopBar";

export default function Layout({ title, subtitle, children }) {
  return (
    <div className="app-shell">
      <Sidebar />
      <div className="flex flex-col min-w-0">
        <TopBar title={title} subtitle={subtitle} />
        <main className="flex-1 p-4 sm:p-6" data-testid="page-main">
          {children}
        </main>
      </div>
      <BottomNav />
    </div>
  );
}
